// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.growth-progress .growth-chart-container {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.growth-progress .growth-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 30px;
}
.growth-progress .growth-stats .stat-card {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}
.growth-progress .growth-stats .stat-card .stat-label {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
}
.growth-progress .growth-stats .stat-card .stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}
.growth-progress .growth-stats .stat-card .stat-change {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.growth-progress .growth-stats .stat-card .stat-change.positive {
  color: #16a34a;
}
.growth-progress .growth-stats .stat-card .stat-change.negative {
  color: #dc2626;
}
.growth-progress .growth-stats .stat-card .stat-change.neutral {
  color: #64748b;
}

.diagnostic-section.growth-progress {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.diagnostic-section.growth-progress .section-header {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}
.diagnostic-section.growth-progress .section-header h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 8px;
}
.diagnostic-section.growth-progress .section-header p {
  color: #666;
  font-size: 16px;
  margin-bottom: 15px;
}
.diagnostic-section.growth-progress .section-header .info-tooltip {
  position: absolute;
  top: 0;
  right: 20px;
  display: inline-block;
  cursor: help;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #007bff;
  color: white;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  transition: transform 0.2s ease;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .info-icon:hover {
  transform: scale(1.1);
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background-color: #fff;
  color: #333;
  text-align: left;
  padding: 15px;
  border-radius: 8px;
  font-size: 13px;
  width: 300px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
  border: 1px solid #e9ecef;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 20px;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content h4 {
  margin: 0 0 10px 0;
  color: #007bff;
  font-size: 14px;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content p {
  margin: 0 0 8px 0;
  line-height: 1.4;
  color: #333;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content ul,
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content ol {
  margin: 0 0 8px 0;
  padding-left: 20px;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content ul li,
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content ol li {
  margin-bottom: 5px;
  line-height: 1.4;
  color: #333;
}
.diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text .tooltip-content strong {
  color: #495057;
}
.diagnostic-section.growth-progress .section-header .info-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: translateY(5px);
}
.diagnostic-section.growth-progress .growth-progress-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  justify-content: center;
}
.diagnostic-section.growth-progress .growth-progress-content .pyramid-chart {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details {
  width: 100%;
  gap: 20px;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section {
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 100%;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #fff;
  cursor: pointer;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .section-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .section-header .toggle-icon {
  font-size: 12px;
  color: #6c757d;
  transition: transform 0.3s ease;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .section-header .toggle-icon.expanded {
  transform: rotate(180deg);
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item {
  background: #fff;
  padding: 12px 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .topic-name {
  font-size: 14px;
  color: #333;
  flex: 1 1;
  margin-right: 10px;
  overflow-wrap: anywhere;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.basic {
  background: #ffebee;
  color: #c62828;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.inProgress {
  background: #fff3e0;
  color: #ef6c00;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.mastered {
  background: #e8f5e9;
  color: #2e7d32;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #fff;
  border-top: 1px solid #e9ecef;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .pagination-controls button {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background: #fff;
  color: #495057;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .pagination-controls button:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #adb5bd;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .pagination-controls .page-info {
  font-size: 14px;
  color: #6c757d;
}
@media (max-width: 767px) {
  .diagnostic-section.growth-progress .section-header .info-tooltip {
    right: 10px;
  }
  .diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text {
    width: 280px;
    max-width: 90vw;
    right: 0;
    transform: none;
  }
  .diagnostic-section.growth-progress .section-header .info-tooltip .tooltip-text::after {
    right: 10px;
  }
  .diagnostic-section.growth-progress .section-header .info-tooltip:hover .tooltip-text {
    transform: translateY(5px);
  }
  .diagnostic-section.growth-progress .growth-progress-content .topics-details .topics-section .topics-list {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/Diagnostic/components/GrowthProgress/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAGI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AADN;AAGM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AADR;AAIM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAKM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AAMQ;EACE,cAAA;AAJV;AAOQ;EACE,cAAA;AALV;;AAYA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AATF;AAWE;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;AATJ;AAWI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AATN;AAYI;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AAVN;AAaI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;AAXN;AAaM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;AAXR;AAaQ;EACE,qBAAA;AAXV;AAeM;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,0CAAA;EACA,UAAA;EACA,wCAAA;EACA,yBAAA;AAbR;AAeQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;AAbV;AAiBU;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAfZ;AAkBU;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAhBZ;AAmBU;;EAEE,iBAAA;EACA,kBAAA;AAjBZ;AAmBY;;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAhBd;AAoBU;EACE,cAAA;AAlBZ;AAuBM;EACE,mBAAA;EACA,UAAA;EACA,0BAAA;AArBR;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAxBN;AA2BI;EACE,WAAA;EACA,SAAA;AAzBN;AA2BM;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AAzBR;AA2BQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AAzBV;AA2BU;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAzBZ;AA4BU;EACE,eAAA;EACA,cAAA;EACA,+BAAA;AA1BZ;AA4BY;EACE,yBAAA;AA1Bd;AA+BQ;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA7BV;AA+BU;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;AA7BZ;AA+BY;EACE,2BAAA;EACA,wCAAA;AA7Bd;AAgCY;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;AA9Bd;AAiCY;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA/Bd;AAiCc;EACE,mBAAA;EACA,cAAA;AA/BhB;AAkCc;EACE,mBAAA;EACA,cAAA;AAhChB;AAmCc;EACE,mBAAA;EACA,cAAA;AAjChB;AAuCQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AArCV;AAuCU;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AArCZ;AAuCY;EACE,mBAAA;EACA,qBAAA;AArCd;AAwCY;EACE,YAAA;EACA,mBAAA;AAtCd;AA0CU;EACE,eAAA;EACA,cAAA;AAxCZ;AA+CE;EAEI;IACE,WAAA;EA9CN;EAgDM;IACE,YAAA;IACA,eAAA;IACA,QAAA;IACA,eAAA;EA9CR;EAgDQ;IACE,WAAA;EA9CV;EAkDM;IACE,0BAAA;EAhDR;EAwDQ;IACE,0BAAA;EAtDV;AACF","sourcesContent":[".growth-progress {\n  .growth-chart-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 40px;\n  }\n\n  .growth-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin-top: 30px;\n\n    .stat-card {\n      background-color: #f8fafc;\n      border-radius: 8px;\n      padding: 20px;\n      border: 1px solid #e2e8f0;\n\n      .stat-label {\n        font-size: 14px;\n        color: #64748b;\n        margin-bottom: 8px;\n      }\n\n      .stat-value {\n        font-size: 24px;\n        font-weight: 600;\n        color: #1e293b;\n        margin-bottom: 4px;\n      }\n\n      .stat-change {\n        font-size: 12px;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        &.positive {\n          color: #16a34a;\n        }\n\n        &.negative {\n          color: #dc2626;\n        }\n\n        &.neutral {\n          color: #64748b;\n        }\n      }\n    }\n  }\n}\n\n.diagnostic-section.growth-progress {\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .section-header {\n    margin-bottom: 30px;\n    text-align: center;\n    position: relative;\n\n    h2 {\n      font-size: 24px;\n      color: #333;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: #666;\n      font-size: 16px;\n      margin-bottom: 15px;\n    }\n\n    .info-tooltip {\n      position: absolute;\n      top: 0;\n      right: 20px;\n      display: inline-block;\n      cursor: help;\n\n      .info-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 24px;\n        height: 24px;\n        background: #007bff;\n        color: white;\n        border-radius: 50%;\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 1;\n        transition: transform 0.2s ease;\n\n        &:hover {\n          transform: scale(1.1);\n        }\n      }\n\n      .tooltip-text {\n        visibility: hidden;\n        position: absolute;\n        z-index: 1;\n        top: 100%;\n        right: 0;\n        margin-top: 10px;\n        background-color: #fff;\n        color: #333;\n        text-align: left;\n        padding: 15px;\n        border-radius: 8px;\n        font-size: 13px;\n        width: 300px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n        opacity: 0;\n        transition: opacity 0.3s, transform 0.3s;\n        border: 1px solid #e9ecef;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: 100%;\n          right: 20px;\n          margin-left: -5px;\n          border-width: 5px;\n          border-style: solid;\n          border-color: transparent transparent #fff transparent;\n        }\n\n        .tooltip-content {\n          h4 {\n            margin: 0 0 10px 0;\n            color: #007bff;\n            font-size: 14px;\n          }\n\n          p {\n            margin: 0 0 8px 0;\n            line-height: 1.4;\n            color: #333;\n          }\n\n          ul,\n          ol {\n            margin: 0 0 8px 0;\n            padding-left: 20px;\n\n            li {\n              margin-bottom: 5px;\n              line-height: 1.4;\n              color: #333;\n            }\n          }\n\n          strong {\n            color: #495057;\n          }\n        }\n      }\n\n      &:hover .tooltip-text {\n        visibility: visible;\n        opacity: 1;\n        transform: translateY(5px);\n      }\n    }\n  }\n\n  .growth-progress-content {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    align-items: center;\n    justify-content: center;\n\n    .pyramid-chart {\n      display: flex;\n      justify-content: center;\n      margin-bottom: 20px;\n    }\n\n    .topics-details {\n      width: 100%;\n      gap: 20px;\n\n      .topics-section {\n        background: #f8f9fa;\n        border-radius: 8px;\n        overflow: hidden;\n        transition: all 0.3s ease;\n        width: 100%;\n\n        .section-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 15px 20px;\n          background: #fff;\n          cursor: pointer;\n          border-bottom: 1px solid #e9ecef;\n          margin-bottom: 0;\n\n          h3 {\n            margin: 0;\n            font-size: 18px;\n            color: #333;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n          }\n\n          .toggle-icon {\n            font-size: 12px;\n            color: #6c757d;\n            transition: transform 0.3s ease;\n\n            &.expanded {\n              transform: rotate(180deg);\n            }\n          }\n        }\n\n        .topics-list {\n          display: grid;\n          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n          gap: 15px;\n          padding: 20px;\n          max-height: 400px;\n          overflow-y: auto;\n\n          .topic-item {\n            background: #fff;\n            padding: 12px 15px;\n            border-radius: 6px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n            transition: transform 0.2s ease;\n\n            &:hover {\n              transform: translateY(-2px);\n              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n            }\n\n            .topic-name {\n              font-size: 14px;\n              color: #333;\n              flex: 1;\n              margin-right: 10px;\n              overflow-wrap: anywhere;\n            }\n\n            .status-badge {\n              padding: 4px 8px;\n              border-radius: 4px;\n              font-size: 12px;\n              font-weight: 500;\n\n              &.basic {\n                background: #ffebee;\n                color: #c62828;\n              }\n\n              &.inProgress {\n                background: #fff3e0;\n                color: #ef6c00;\n              }\n\n              &.mastered {\n                background: #e8f5e9;\n                color: #2e7d32;\n              }\n            }\n          }\n        }\n\n        .pagination-controls {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          gap: 15px;\n          padding: 15px;\n          background: #fff;\n          border-top: 1px solid #e9ecef;\n\n          button {\n            padding: 8px 16px;\n            border: 1px solid #dee2e6;\n            background: #fff;\n            color: #495057;\n            border-radius: 4px;\n            cursor: pointer;\n            transition: all 0.2s ease;\n\n            &:hover:not(:disabled) {\n              background: #f8f9fa;\n              border-color: #adb5bd;\n            }\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n\n          .page-info {\n            font-size: 14px;\n            color: #6c757d;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 767px) {\n    .section-header {\n      .info-tooltip {\n        right: 10px;\n\n        .tooltip-text {\n          width: 280px;\n          max-width: 90vw;\n          right: 0;\n          transform: none;\n\n          &::after {\n            right: 10px;\n          }\n        }\n\n        &:hover .tooltip-text {\n          transform: translateY(5px);\n        }\n      }\n    }\n\n    .growth-progress-content {\n      .topics-details {\n        .topics-section {\n          .topics-list {\n            grid-template-columns: 1fr;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
